"use client";

import { useLanguage } from "@/hooks/useLanguage";

export default function Footer() {
	const { language } = useLanguage();

	return (
		<footer className="w-full p-4 text-center text-sm text-light-text/60 dark:text-dark-text/60">
			<p>
				{language === "zh" ? (
					<>© 2025 Baby Odin. 保留所有权利。</>
				) : (
					<>© 2025 Baby Odin. All rights reserved.</>
				)}
			</p>
		</footer>
	);
}
